import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const NewSave: FC<ISvG> = ({ width = 16, height = 16, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.8125 17.5V12.8125H7.1875V17.5M17.5 7.96415V15.625C17.5 16.6605 16.6605 17.5 15.625 17.5H4.375C3.33947 17.5 2.5 16.6605 2.5 15.625V4.375C2.5 3.33947 3.33947 2.5 4.375 2.5H12.0358C12.5331 2.5 13.01 2.69754 13.3617 3.04917L16.9508 6.63833C17.3025 6.98996 17.5 7.46687 17.5 7.96415Z"
      stroke="#FF9E1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(NewSave);
